/* unplugin-vue-components disabled */import script from "./goldListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./goldListItem.vue?vue&type=script&setup=true&lang=js"

import "./goldListItem.vue?vue&type=style&index=0&id=056cfd80&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-056cfd80"]])

export default __exports__